import { siKuaishou, siTiktok, siWechat, siXiaohongshu } from 'simple-icons'
import { platformMeta } from '../utils/formatters'

const iconMap = { douyin: siTiktok, xiaohongshu: siXiaohongshu, kuaishou: siKuaishou, wechat: siWechat }

export function PlatformIcon({ platform, small = false, plain = false }) {
  const meta = platformMeta[platform] || platformMeta.wechat
  const brand = iconMap[platform] || siWechat
  return <span className={`platform-icon ${small ? 'small' : ''} ${plain ? 'plain' : ''}`} style={{ background: plain ? 'transparent' : meta.color, color: plain ? meta.color : '#fff' }}><svg viewBox="0 0 24 24" aria-hidden="true"><path d={brand.path}/></svg></span>
}
